// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import Html5FilledSvg from "@fishx/icons-svg/es/asn/Html5Filled";
import FishxIcon from '../components/FishxIcon';

var Html5Filled = function Html5Filled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: Html5FilledSvg
  }));
};

Html5Filled.displayName = 'Html5Filled';
export default React.forwardRef(Html5Filled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/Html5Filled.js
// module id = 2948
// module chunks = 0